import type { OpportunityHeadline } from './types';

/** Walk-In / Walk-Out playbook — copied from mock-appointment-detail (reference). */
export const REFERENCE_WALKIN_HEADLINES: OpportunityHeadline[] = [
  {
    id: 'greet',
    icon: 'heart',
    source: 'guideline',
    headline: 'Greet warmly by name',
    detail:
      'Smile and stand up when the patient walks in. Use her name: "Hi Mrs Campbell, welcome!" She\'s a new patient — add: "We\'re so happy to meet you today."',
  },
  {
    id: 'rapport',
    icon: 'team',
    source: 'guideline',
    headline: 'Build rapport — keep it light',
    detail:
      'Ask a friendly question unrelated to treatment: "Was traffic okay?" or "Have you been to this area before?" Highlight care philosophy: "Our goal is to make sure you feel fully informed and comfortable."',
  },
  {
    id: 'handoff',
    icon: 'right',
    source: 'guideline',
    headline: 'Trust handoff to Dr. Carter',
    detail:
      'Set up the doctor transition: "Dr. Emily Carter will take great care of you — she\'s wonderful with first-time patients."',
  },
  {
    id: 'anxiety',
    icon: 'flame',
    source: 'elva',
    headline: 'Anxiety flag — prep quiet operatory',
    detail:
      'Patient has anxiety flag in chart. Offer nitrous before procedure (always — per chart). Prep Op-3 (quietest).',
  },
];

export function referenceWalkoutHeadlines(collectToday: string): OpportunityHeadline[] {
  const amount = collectToday.match(/\$[\d,]+/)?.[0] ?? '$45';
  const collectHeadline = collectToday.toLowerCase().includes('copay')
    ? `Collect ${amount} copay`
    : collectToday.startsWith('$0')
      ? `Collect ${amount}`
      : `Collect ${amount}`;

  return [
    {
      id: 'next-appt',
      icon: 'calendar',
      source: 'guideline',
      headline: 'Book next appointment before checkout',
      detail:
        'Recommend 6-month recall. Offer "Same time and day works again?" to make booking easy. If she hesitates, offer 2 specific options (e.g., Tue 10am or Thu 4pm).',
    },
    {
      id: 'family',
      icon: 'team',
      source: 'guideline',
      headline: 'Family opportunity — husband + son overdue',
      detail:
        'Sara is the household decision-maker. Mention: "We noticed it\'s been 8 months since Michael\'s last cleaning — would you like to book him too while you\'re here?"',
    },
    {
      id: 'whitening',
      icon: 'sparkle',
      source: 'elva',
      headline: 'Whitening estimate — wedding timeline',
      detail:
        'Patient expressed interest during cleaning. Wedding is in October — frame around that timeline. Print the estimate, attach a treatment plan. Offer financing option if asked.',
    },
    {
      id: 'collect',
      icon: 'dollar',
      source: 'guideline',
      headline: collectHeadline,
      detail:
        'Collect copay before she leaves. Process Sunlife PPO claim. Email receipt to the address on file.',
    },
  ];
}

export const REFERENCE_WALKIN_SUMMARY = [
  'Mom of 3 with $1,200 unscheduled treatment across the family. Worth a warm onboarding — long-term household potential.',
  'Anxiety flag in chart. Offer nitrous before procedure; prep Op-3 (the quiet room). She shuts down if rushed.',
];

export const REFERENCE_WALKOUT_SUMMARY = [
  'Mention husband + son are both 8 months overdue. Sara\'s the household decision-maker — book all 3 today if she\'s open.',
  'Discuss whitening estimate before she leaves (Dr. Carter mentioned interest during cleaning). Use the wedding timeline as the framing.',
];
